var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { isolateComponent } from '@zapier/style-encapsulation';
import { css } from '@emotion/react';
import { SubscriptionForm, } from './SubscriptionForm';
import { DisclaimerText } from './DisclaimerText';
const Styles = {
    ctaContainer: css `
    text-align: center;
    display: flex;
    align-items: stretch;
    flex-direction: column;
    text-align: left;
  `,
};
export const SubscriptionFormWithDisclaimer = (_a) => {
    var { disclaimerTextColor = 'primary', disclaimerTextType } = _a, restProps = __rest(_a, ["disclaimerTextColor", "disclaimerTextType"]);
    return (isolateComponent("div", { css: Styles.ctaContainer },
        isolateComponent(SubscriptionForm, Object.assign({}, restProps, { fluidInput: true })),
        isolateComponent(DisclaimerText, { color: disclaimerTextColor, textType: disclaimerTextType })));
};
//# sourceMappingURL=SubscriptionFormWithDisclaimer.js.map
// @zapier/design-system@6.1.0 (fd86aa2ab)
